import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import placeHolder from "../../../assets/safe_logo.png";
import { useTranslation } from "react-i18next";
import storePersist, { localConstant } from "../../../services/localStorage";
import { changeStatusToSignInProgress } from "../../../redux/storageDocument/action";
import { useDispatch } from "react-redux";

const TIMER_VALUE = 10;

const ESignVerification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const timer = useRef(TIMER_VALUE);
  const renderElement = useRef(0);
  let timerConst = null;

  const startTimer = () => {
    timerConst = setInterval(() => {
      timer.current = timer.current - 1;
      renderElement.current.innerText = timer.current;
      if (timer.current <= 1) {
        clearTimeout(timerConst);
        navigate("/ownerDashboard");
      }
    }, 1000);
  };

  useEffect(() => {
    startTimer();
    if (
      storePersist.get(localConstant.AGREEMENT_STATUS) === "IN_PRGRS" ||
      storePersist.get(localConstant.AGREEMENT_STATUS) === "IN_PROGESS" ||
      storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLTD" ||
      storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLETED"
    )
      return navigate("/ownerDashboard");
    else
      dispatch(
        changeStatusToSignInProgress(
          storePersist.get(localConstant.AGREEMENT_ID),
          (response) => {
            if (
              response?.statusCode === 200 ||
              response?.response?.status === 400
            ) {
              storePersist.set(localConstant.AGREEMENT_STATUS, "IN_PRGRS");
              storePersist.set(
                localConstant.TIMESTAMP_FOR_ESIGN,
                new Date().getTime(),
              );
            }
            // navigate("/ownerDashboard");
          },
        ),
      );
  }, []);

  const onClickSubmitButton = () => {
    navigate("/ownerDashboard");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={placeHolder}
        style={{
          width: 317,
          height: 240,
          margin: "2%",
          marginTop: "15%",
        }}
        alt=""
      />
      <div
        style={{
          textAlign: "center",
          fontSize: "120%",
          margin: "10%",
          marginTop: "0",
        }}
      >
        <span style={{ fontFamily: "Segoe UI" }}>
          Please wait for <span ref={renderElement}>{timer.current}</span>{" "}
          seconds while we update the status or{" "}
        </span>
        <Button
          size="large"
          type="submit"
          variant="contained"
          style={{
            backgroundColor: "#1D5AB9",
            borderColor: "#1D5AB9",
            color: "white",
            margin: "5%",
            boxShadow: "none",
          }}
          onClick={() => onClickSubmitButton()}
        >
          {t("pages.esignVerification.text02")}
        </Button>
      </div>
    </div>
  );
};

export default ESignVerification;
